import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import _ from "lodash";
import Flickity from "react-flickity-component";
import { withToastManager } from "react-toast-notifications";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { Translate, I18n } from "react-redux-i18n";
import { ContentContainer } from "../../Components/Common/ContentContainer";
import Layout from "../../Layouts/LayoutMain";
import Constants from "../../AppConstants/Constants";
import Utilities from "../../Helpers/Utilities";
import RelatedProducts from "../../Components/Common/RelatedProducts";
import WirelessPlan from "../../Components/Common/WirelessPlan";
import Modal from "react-modal";
import { ProductDetailLoader } from "../../Components/Loaders/Loaders";
import { getProductDetails } from "../../Store/Product/Actions";
import { selectProduct } from "../../Store/Catalog/Actions";
import { getXsrfToken } from "../../Store/Security/Actions";
import { addToCart as addToNopCommerceCart } from "../../Store/Cart/Actions";
import DropdownList from "../../Components/Common/DropdownList";
import { Field, reduxForm } from "redux-form";
import AttributeDropdown from "../../Components/Common/AttributeDropdown";
Modal.setAppElement("#react-app");


class ProductDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quantity: 1,
            initialIndex: 0,
            currentImage: null,
            drag: false,
            optionClicked: {},
            attributeInfo: [],
            numberOfSelections: -1
        };

        this.addToCart = this.addToCart.bind(this);
        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.openPlanModal = this.openPlanModal.bind(this);
        this.closePlanModal = this.closePlanModal.bind(this);
    }

    componentWillMount() {
        const { selectedProduct: product } = this.props;
        const queryStringParameters = Utilities.getQueryStringParameters(this.props.location.search);

        if (queryStringParameters.quantity !== "undefined") {
            this.setState({ quantity: parseInt(queryStringParameters.quantity) });
        }

        this.props.getProductDetails(queryStringParameters.product, false, false, true, Utilities.scrollToTop);

        _.each(product.productAttributes, pA => {
            if (pA.defaultValue) {
                this.selectOption(pA.defaultValue);
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        const { selectedProduct: product } = this.props;
        const thisQueryStringParameters = Utilities.getQueryStringParameters(this.props.location.search);
        const nextQueryStringParameters = Utilities.getQueryStringParameters(nextProps.location.search);
        // if the query parameter for product id is different from the one currently on, get details for the new product
        // once it gets details and receive props is called again the params will match and not get details again
        // this is to get related products when click back nav button, or getting details when clicking on a related product
        if (thisQueryStringParameters.product !== nextQueryStringParameters.product) {
            this.props.getProductDetails(nextQueryStringParameters.product, false, false, true, Utilities.scrollToTop);
        }

        _.each(product.productAttributes, pA => {
            if (pA.defaultValue) {
                this.selectOption(pA.defaultValue);
            }
        })
    }

    openPlanModal() {
        this.setState({ modalIsOpen: true });
    }

    closePlanModal() {
        this.setState({ modalIsOpen: false });
    }

    addToCart() {
        const { toastManager, getXsrfToken, addToNopCommerceCart, updateQuantity, selectedProduct: product, config: { DEVICES_CATEGORY_ID } } = this.props;
        const { quantity, optionClicked, attributeInfo } = this.state;

        if (quantity === 0) {
            alert(I18n.t("alerts.quantity"));
        } else {
            if (updateQuantity && typeof updateQuantity === "function") {
                updateQuantity(quantity);
            }

            if (product.category.id !== DEVICES_CATEGORY_ID) {
                toastManager.add(I18n.t("alerts.addedToCart", { quantity: quantity, name: product.name }), {
                    appearance: "success",
                    autoDismiss: true,
                    icon: faShoppingCart
                });
            }

            getXsrfToken(({ token }) => {
                const item = {
                    ProductId: product.id,
                    Quantity: quantity
                };

                if (optionClicked) {
                    item.AttributeControlIds = attributeInfo;
                }

                addToNopCommerceCart({
                    items: [item],
                    __RequestVerificationToken: token
                }, true, data => {
                    const id = _.find(data.items, i => i.productId === product.id).id;
                    this.addToCartCb(id, quantity);
                });
            });
        }
    }

    addToCartCb(id, quantity) {
        this.setState({
            deviceAddedToCartId: id,
            quantity: quantity
        });

        this.openPlanModal();
    }

    onQuantityChange(quantity) {
        const { updateQuantity } = this.props;
        quantity = quantity === "" ? 0 : parseInt(quantity);

        this.setState({ quantity });

        if (updateQuantity && typeof updateQuantity === "function") {
            updateQuantity(quantity);
        }
    }

    selectOption(option) {
        const { selectedProduct: product } = this.props;
        const { attributeInfo } = this.state;
        let attr = "";
        let tempAttrInfoArray = [];
        let numberOfSelections = 0;

        for (let i = 0; i < product.productAttributes.length; i++) {
            if (product.productAttributes[i].attributeControlType === 1) {
                numberOfSelections++;
            }
            for (let j = 0; j < product.productAttributes[i].values.length; j++) {
                if (product.productAttributes[i].values[j].id === parseInt(option)) {
                    attr = `product_attribute_${product.id}_${product.productAttributes[i].productAttributeId}_${product.productAttributes[i].values[j].productAttributeMappingId}_${option}`;
                }
            }
        }

        _.each(attributeInfo, ai => {
            const aiValue = ai.substr(0, ai.lastIndexOf("_"));
            const attrValue = attr.substr(0, attr.lastIndexOf("_"));
            if (aiValue !== attrValue) {
                tempAttrInfoArray.push(ai);
            }
        });

        if (parseInt(option) === 0) {
            numberOfSelections--;
        } else {
            tempAttrInfoArray.push(attr);
        }

        this.setState({ optionClicked: option, attributeInfo: tempAttrInfoArray, numberOfSelections: numberOfSelections });
    }

    renderPictures() {
        const { selectedProduct } = this.props;

        if (selectedProduct.pictureModels && selectedProduct.pictureModels.length > 1) {
            return _.map(selectedProduct.pictureModels, picture =>
                <img key={picture.id} className="slide" alt={picture.alternateText} height={100} src={picture.fullSizeImageUrl} onMouseEnter={e => {
                    this.setState({
                        drag: e.target.offsetLeft,
                        initialIndex: _.findIndex(document.getElementsByClassName("slide"), slide => slide.className.includes("is-selected"))
                    });
                }} onClick={e => {
                    if (e.target.offsetLeft === this.state.drag) {
                        this.setState({ currentImage: picture.fullSizeImageUrl });
                    } else {
                        this.setState({ drag: false });
                    }
                }} style={{ paddingLeft: 10, paddingRight: 10 }} />
            );
        }
    }

    renderProdAttr(productAttributes) {
        const { optionClicked } = this.state;

        return _.map(productAttributes, prodAttr =>
            <div className="row" style={{ padding: "0px 0px 0px 15px" }}>
                {(prodAttr.attributeControlType === 1 || prodAttr.attributeControlType === 2) && 
                    <form>
                        <label style={{ fontWeight: "bold" }}>
                        {prodAttr.name}
                            <select style={{ WebkitAppearance: "menulist" }} onChange={e => this.selectOption(e.target.value)}>
                            {!prodAttr.defaultValue &&
                                <option key={"selectDefault_" + prodAttr.name} value="0">Select...</option>
                            }
                                {this.renderProdAttrValues(prodAttr.values)}
                            </select>
                        </label>
                    </form>                
                }
                {(prodAttr.attributeControlType === 50 || prodAttr.attributeControlType === 40 || prodAttr.attributeControlType === 45) && optionClicked === prodAttr.conditionValue &&
                    <p>{ prodAttr.textPrompt }</p>
                }
            </div>

            )
    }

    renderProdAttrValues(values) {
        const { selectedProduct: product } = this.props;

        return _.map(values, prodAttrValue =>
            <option key={prodAttrValue.id} value={prodAttrValue.id}>{prodAttrValue.name} {parseFloat(prodAttrValue.priceAdjustment.replace("$", "")) > 0 ? "(+" + prodAttrValue.priceAdjustment + ")" : ""}</option>
            );
    }

    render() {
        const { selectedProduct: product, showDetails, isAuthenticated, location: { pathname }, config: { DEVICES_CATEGORY_ID } } = this.props;
        const { initialIndex, currentImage, deviceAddedToCartId, attributeInfo, numberOfSelections } = this.state;
        let backPath = pathname.split("/details")[0];
        let pathName = backPath.split("/")[1];
        let displayedPathName = pathName.charAt(0).toUpperCase() + pathName.slice(1);
        // redirect for backpath to kits shop if user clicks details of related product from details of shop kit product
        if (backPath === "/kits") {
            backPath = Constants.ENDPOINTS.KITS;
        }

        const noReqProducts = _.filter(product.requiredProducts, p => !p.automaticallyAddToCart);

        return (
            <Layout isAuthenticated={isAuthenticated}>
                {(!product || !product.id) &&
                <ContentContainer size="lg" containerClassName="product-details-container" style={{ paddingTop: "50px" }}>
                    <div className="row justify-content-around">
                        <div className="col-md-12">
                            <ProductDetailLoader/>
                        </div>
                    </div>
                </ContentContainer>}

                {product && product.id &&
                <ContentContainer size="lg" containerClassName="product-details-container" style={{ paddingTop: "50px" }}>
                    <div className="row">
                        <div className="col-md-12">
                            <ol className="breadcrumbs">
                                <li>
                                    <Link to={backPath}>{displayedPathName}</Link>
                                </li>
                                <li>{product.name}</li>
                            </ol>
                        </div>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-md-6 col-lg-3">
                            <img alt="Image" src={currentImage || product.defaultPictureModel.fullSizeImageUrl} />

                            <div className="row">
                                <div className="col-12">
                                    <div className="slider">
                                        <Flickity
                                            className={"slides"} // default ''
                                            elementType={"ul"} // default 'div'
                                            options={{
                                                cellSelector: ".slide",
                                                cellAlign: "left",
                                                wrapAround: true,
                                                pageDots: true,
                                                prevNextButtons: false,
                                                autoPlay: true,
                                                // draggable: product.pictureModels.length >= 2,
                                                draggable: false,
                                                imagesLoaded: true,
                                                accessibility: true,
                                                rightToLeft: false,
                                                initialIndex: initialIndex
                                            }} // takes flickity options {}
                                            disableImagesLoaded={false} // default false
                                            reloadOnUpdate // default false
                                        >
                                            {this.renderPictures()}
                                        </Flickity>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-9">
                            <h2>{product.name}</h2>
                            <div className={product.displayStockAvailability ? "product-sku2" : "product-sku"}><span className="part-number"><Translate value="misc.partNumber" />: </span>{product.sku}</div>
                            {product.displayStockAvailability && product.displayStockQuantity &&
                                <div className="stock-availability"><span className="availability"><Translate value="misc.availability" />: </span>{product.stockQuantity > product.minStockQuantity ? product.stockQuantity : ""} <Translate value={product.stockQuantity > product.minStockQuantity ? "misc.inStock" : "misc.outOfStock"} /></div>
                            }
                            {product.displayStockAvailability && !product.displayStockQuantity &&
                                <div className="stock-availability"><span className="availability"><Translate value="misc.availability" />: </span><Translate value={product.stockQuantity > product.minStockQuantity ? "misc.inStock" : "misc.outOfStock"} /></div>
                            }
                            <div className="text-block">
                                <span className="h4 inline-block">{product.productPrice.price}</span>
                            </div>
                            <div className="product-details-content" dangerouslySetInnerHTML={{ __html: product.fullDescription }} />

                            {product.productAttributes.length > 0 && product.category.id !== DEVICES_CATEGORY_ID &&
                                <div>
                                {this.renderProdAttr(product.productAttributes)}
                                {/*    <AttributeDropdown selectedProduct={product} productAttributes={product.productAttributes} selectOption={()=>this.selectOption}/>*/}
                                </div>
                            }

                            <div className="row" style={{ marginTop: 15 }}>
                                <div className="col-4 col-sm-4 col-lg-2">
                                    <input type="number" placeholder={I18n.t("abbreviations.quantity")} min={0} value={this.state.quantity} onChange={e => this.onQuantityChange(e.target.value)} />
                                </div>
                                <div className="col-8 col-sm-8 col-lg-4" style={{ paddingLeft: 0 }}>
                                    <button type="button" disabled={product.productAttributes.length > 0 && numberOfSelections !== attributeInfo.length || product.stockQuantity <= product.minStockQuantity} className="btn btn--primary" style={{ width: "100%" }} onClick={this.addToCart}><Translate value="misc.addToCart" /></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* related products */}
                    { product.relatedProducts && product.relatedProducts.length > 0 &&
                    <section>
                        <div className="container related-products-container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-block">
                                        <h3><Translate value="relatedProducts.title" /></h3>
                                    </div>
                                </div>
                                <RelatedProducts product={product} showDetails={showDetails} />
                            </div>
                        </div>
                    </section>
                    }

                    {/* offer plan modal for devices */}
                    { product.category.id === DEVICES_CATEGORY_ID && noReqProducts &&
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={this.closePlanModal}
                        contentLabel="select-wireless-plan"
                        className="modal-content"
                        overlayClassName="modal-container add-plan-modal modal-active"
                        shouldCloseOnOverlayClick={false}
                        shouldCloseOnEsc={false}
                    >
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-md-12">
                                    <h3><Translate value="dataPlans.title" /></h3>
                                </div>
                            </div>
                            <div className="masonry">
                                <div className="row masonry__container masonry--active">
                                    {
                                        _.map(noReqProducts, product =>
                                            <WirelessPlan
                                                key={product.id}
                                                image={product.defaultPictureModel.fullSizeImageUrl}
                                                title={product.name}
                                                price={product.productPrice.price}
                                                product={product}
                                                productAttributes={product.productAttributes}
                                                closePlanModal={this.closePlanModal}
                                                deviceQuantity={this.state.quantity}
                                                selectedDeviceId={deviceAddedToCartId}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Modal>
                    }

                </ContentContainer>}
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        config: state.config,
        selectedProduct: state.selectedProduct
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getXsrfToken: getXsrfToken,
        addToNopCommerceCart: addToNopCommerceCart,
        getProductDetails: getProductDetails,
        selectProduct: selectProduct
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withToastManager(ProductDetails));
